import React from 'react'
import { Button, Layout, theme, Dropdown, Space, Avatar  } from 'antd';
import {
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,

} from '@ant-design/icons';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';

const { Header } = Layout;



function TopHeader(props) {


  // const [collapsed, setCollapsed] = useState(true)
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const items = [
    {
      key: '1',
      label: <Link to="/profile">修改個人資料</Link>,
    },
    {
      key: '2',
      label: (
        <a target="_blank" rel="noopener noreferrer"
          onClick={()=>{
            logout()
          }}
        >
          登出
        </a>
      ),
      danger: true,
    },
  ];

  const logout = () => {
    axios.post('/api/logout').then(res=>{
      props.logout();
      document.cookie = 'XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      props.history.replace('/login')
    }).catch(err=>{
      console.error('登出失敗',err)
    })

  }

  const handleCollapseChange = () => {
    //改變state的狀態，透過dispatch
    props.changeCollapsed()
  }
  return (
    <Header
        style={{
          padding:'0',
          background: colorBgContainer,
        }}
      >
        <Button
          type="text"
          icon={props.isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={()=>handleCollapseChange()}
          style={{
            fontSize: '16px',
            width: 40,
            height: 40,
            paddingLeft: '12px',
          }}
        />
        <div style={{float:'right', paddingRight:'24px'}}>
          <span>Hi <span style={{ color: '#1890ff'}}>{ props.user.chinese_name === null? props.user.name : props.user.chinese_name }</span>, 歡迎回來 </span>
          <Dropdown menu={{items}}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                 <Avatar size="large" icon={<UserOutlined />} />
              </Space>
            </a>
          </Dropdown>
        </div>
      </Header>
  )
}

/**
 * @returns connect(
 * //mapStateToProps
 * //mapDispatchTOProps
 * )(被包裝的組件)
 */

const mapStateToProps = ({
  collapsedReducer:{isCollapsed},
  userProfileReducer: {user}
}) => ({
  isCollapsed,
  user
})

const mapDispatchToProps = {
  changeCollapsed(){
    return {
      type: 'change_collapsed'
      //payload
    }
  },
  logout(){
    return {
      type: 'logout'
    }
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(TopHeader))
